import type { TimeSeriesChartStatus } from '../types/TimeSeriesChartStatus.types';

type GetTimeSeriesChartStatusParams = {
  hasSelection: boolean;
  hasData: boolean;
  isPending: boolean;
  isFetching: boolean;
  isError: boolean;
};

/** Derives the single result-area status from the query flags; see TimeSeriesChartStatus. */
export function getTimeSeriesChartStatus({
  hasSelection,
  hasData,
  isPending,
  isFetching,
  isError,
}: GetTimeSeriesChartStatusParams): TimeSeriesChartStatus {
  if (!hasSelection) {
    return { type: 'empty' };
  }

  if (!hasData) {
    if (isError) {
      return { type: 'error', isRetrying: isFetching };
    }

    if (isPending || isFetching) {
      return { type: 'loading' };
    }
  }

  return { type: 'ready', isRefreshing: isFetching, hasRefreshError: isError };
}
